import { Component, Input } from '@angular/core'

import { PermissionSourceType } from '@core/types/permissions.source'
import { PermissionsService } from '@shared/services/permissions.service'

export interface NavLink {
  path: string
  label: string
  permission?: PermissionSourceType
  exact?: boolean
  order?: number
}

@Component({
  selector: 'lin-tab-nav-bar',
  template: `
    <nav mat-tab-nav-bar [tabPanel]="tabPanel">
      @for (link of navLinks; track link.path) {
        @if (hasPermission(link.permission)) {
          <a
            mat-tab-link
            [routerLink]="link.path"
            routerLinkActive
            [routerLinkActiveOptions]="{ exact: !!link.exact }"
            #rla="routerLinkActive"
            [active]="rla.isActive"
            [attr.data-testid]="'tab-' + link.path.replace('./', '')"
          >
            {{ link.label | translate | uppercase }}
          </a>
        }
      }
    </nav>
    <mat-tab-nav-panel #tabPanel>
      <router-outlet></router-outlet>
    </mat-tab-nav-panel>
  `,
  styles: [
    `
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
      }

      :host ::ng-deep .mat-tab-label,
      .mat-mdc-tab-link {
        color: var(--primary-font-color);
        opacity: 1;
      }

      :host ::ng-deep .mat-mdc-tab-nav-bar,
      :host ::ng-deep .mat-mdc-tab-header {
        border-bottom: 1px solid var(--primary-border-color);
      }

      :host ::ng-deep .mat-mdc-tab-link:hover {
        text-decoration: none !important;
      }
    `,
  ],
  standalone: false,
})
export class TabNavBarComponent {
  @Input() navLinks: NavLink[]

  constructor(private permissionsService: PermissionsService) {}

  hasPermission(permissionType: PermissionSourceType) {
    if (!permissionType) return true
    return this.permissionsService.hasPermissionSync(permissionType)
  }
}
